export default __webpack_public_path__ + "static/media/loader.3bcf8754.gif";